<span class="currency-sign">&#36;</span>
